import { Component } from "@angular/core";
import { SpartaxFormStepBaseComponent } from "../spartax-form-step-base";
import { SpartaxAuftragskunde, SpartaxAuftragskundeArt, SpartaxAuftragskundeUtil } from "src/app/data/dto/spartax/spartax-auftragskunde.dto";
import { SpartaxKundeUtil } from "src/app/data/dto/spartax/spartax-kunde.dto";

@Component({
    selector: 'app-spartax-cq-place-order',
    templateUrl: './spartax-cq-place-order.component.html',
    styleUrls: ['./spartax-cq-place-order.component.scss']
})
export class SpartaxCQPlaceOrderComponent extends SpartaxFormStepBaseComponent {
    private vollmachtMissingMap = new Map<SpartaxAuftragskunde, boolean>();

    getKundeName(ak: SpartaxAuftragskunde): string {
        return SpartaxKundeUtil.getVollstaendigerNameOfKunde(ak.Kunde);
    }

    getAnschrift(ak: SpartaxAuftragskunde): string {
        return SpartaxKundeUtil.getAnschrift(ak.Kunde);
    }

    isKind(ak: SpartaxAuftragskunde): boolean {
        return ak.AuftragsKundeArt === SpartaxAuftragskundeArt.kind;
    }

    setProfileChanged(ak: SpartaxAuftragskunde, value: boolean) {
        ak.CqProfileChanged = value;
        this.modelChange.emit(this.model);
    }

    isVollmachtMissing(ak: SpartaxAuftragskunde): boolean {
        if (!this.vollmachtMissingMap.has(ak)) {
            this.vollmachtMissingMap.set(ak, SpartaxAuftragskundeUtil.isVollmachtMissing(ak));
        }
        return this.vollmachtMissingMap.get(ak);
    }

    setTeilDesAuftrags(ak: SpartaxAuftragskunde, value: boolean) {
        ak.TeilDesAuftrags = value;
        this.modelChange.emit(this.model);
    }

    personHasIncome(auftragskunde: SpartaxAuftragskunde): boolean {
        for (const jahr of auftragskunde.Erklaerungsjahre || []) {
            if ((jahr.EinkunftsArten || []).length > 0) {
                return true;
            }
        }

        for (const jahrAlt of auftragskunde.ErklaerungsjahreAlt || []) {
            if ((jahrAlt.EinkunftsArten || []).length > 0) {
                return true;
            }
        }

        return false;
    }

    override formIsValid(): boolean {
        return (this.model.auftragskunden || []).every(x => x.CqProfileChanged === true || x.CqProfileChanged === false);
    }
}
